<template>
  <!-- <v-avatar
      image="//loremflickr.com/40/40/kitten"
      size="28"
    /> -->
  <v-card>
    <v-card-title>Rechnungsadresse bearbeiten</v-card-title>
    <v-card-text>
      <v-form
        ref="form"
        @submit.prevent="">
        <v-text-field
          v-model="name"
          :rules="[(value) => !!value || 'Name ist erforderlich']"
          label="Name (Privat/Firma)"
          style="margin-bottom: 10px"></v-text-field>
        <v-autocomplete
          :items="countries"
          item-title="name"
          item-value="alpha2"
          v-model="adress_country"
          :rules="[(value) => !!value || 'Land ist erforderlich']"
          label="Land"
          style="margin-bottom: 10px" />
        <v-autocomplete
          :items="statesByCountry"
          item-title="name"
          item-value="code"
          v-model="adress_state"
          :rules="[(value) => !!value || 'Bundesland ist erforderlich']"
          label="Bundesland"
          style="margin-bottom: 10px" />
        <v-text-field
          v-model="adress_plz"
          label="PLZ"
          style="margin-bottom: 10px" />
        <v-text-field
          v-model="adress_city"
          label="Stadt"
          style="margin-bottom: 10px" />
        <v-text-field
          v-model="adress_street"
          label="Straße"
          style="margin-bottom: 10px" />
        <v-text-field
          v-model="adress_houseNumber"
          label="Hausnummer"
          style="margin-bottom: 10px" />
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn @click="changePaymentInformation">Speichern</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script setup lang="ts">
import { computed, onMounted, ref, useTemplateRef } from "vue";
import DeleteWithConfirmationButton from "../tools/DeleteWithConfirmationButton.vue";
import { useAuthStore } from "@/stores/authStore";
import { useSnackbar } from "vuetify-use-dialog";
import { useTranslation } from "i18next-vue";
import countries from "@/utils/countries.json";
import states from "@/utils/states.json";
import axios from "axios";

const statesByCountry = computed(() => {
  if (!adress_country.value) return [];
  return states
    .filter((state) => state.country.toLowerCase() === adress_country.value)
    .map((state) => ({ ...state, code: state.code.split("-")[1] }));
});

const { success = () => {} } = defineProps<{ success: () => void }>();

const { t } = useTranslation();
const createSnackbar = useSnackbar();

const emit = defineEmits(["close"]);

const authStore = useAuthStore();

const name = ref("");
const adress_country = ref("");
const adress_state = ref("");
const adress_plz = ref("");
const adress_city = ref("");
const adress_street = ref("");
const adress_houseNumber = ref("");

const form = useTemplateRef("form");

onMounted(() => {
  if (!authStore.user.stripe) return;
  axios.get("/api/stripe/customer-details").then((response) => {
    name.value = response.data.name;
    adress_country.value = response.data.address.country.toLowerCase();
    adress_state.value = response.data.address.state;
    adress_plz.value = response.data.address.postal_code;
    adress_city.value = response.data.address.city;
    adress_street.value = response.data.address.line1;
    adress_houseNumber.value = response.data.address.line2;
  });
});

async function changePaymentInformation() {
  const valid = await form.value.validate();
  if (!valid.valid) return;
  emit("close");
  axios
    .post(
      "/api/stripe/" +
        (authStore.user.stripe ? "update-customer" : "setup-customer"),
      {
        name: name.value,
        address: {
          country: adress_country.value,
          state: adress_state.value,
          postal_code: adress_plz.value,
          city: adress_city.value,
          line1: adress_street.value,
          line2: adress_houseNumber.value
        }
      }
    )
    .then(() => {
      authStore.user.stripe = true;
      success();
    })
    .catch((error) => {
      console.log(error);
      createSnackbar({
        text: t("validations.invalid-adress"),
        snackbarProps: { color: "error", timeout: 2000 }
      });
    });
}
</script>

<style scoped>
.v-avatar {
  margin-right: 10px;
}
</style>
